<template>
    <div class="container-fluid" id="dvcrud">
        <div class="row">
            <div class="col-md-12">
                <breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="mtdcancelaredicao"></breadcrumb>
            </div>
            <div class="col-md-12">
                <consultaprodutos v-bind:idtabela="vidtabela" v-bind:showprtabela="vshowprtabela"
                    v-bind:filtrotipo="tipopropesquisa"></consultaprodutos>
                <div id="pnlista" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">LISTAGEM DE {{ itensbc.item1.titulo }}</span>
                        <router-link to="/">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                                    aria-hidden="true">&times;</span></button>
                        </router-link>
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
                            <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                                <label for="edidpedidopesq">Nr. Garantia:</label>
                                <input id="edidpedidopesq" type="text" v-mask="'########'"
                                    class="form-control form-control-sm" v-model="pid" @keyup="mtdlimpar_listagem()">
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <span class="lblselect2">Filial:</span>
                                <select id="cbfilialpesq" data-placeholder="Selecione uma filial" v-model="pidfilial"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <span class="lblselect2">Fornecedor:</span>
                                <select id="cbfornecedorpesq" data-placeholder="Selecione um fornecedor"
                                    data-allow-clear="true" style="width:100%;" v-model="pidfornecedor">
                                </select>
                            </div>

                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cbfiltroperiodo">Período:</label>
                                <select class="form-control form-control-sm" id="cbfiltroperiodo"
                                    v-model="pfiltroperiodo" v-bind="selecionaperiodo" @change="mtdlimpar_listagem()">
                                    <option value="0">Não</option>
                                    <option value="1">Sim</option>
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="eddtini">De:</label>
                                <div class="input-group">
                                    <date-picker id="eddtini" v-model="pdtini" :config="options"
                                        class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo"
                                        @change="mtdlimpar_listagem()"></date-picker>
                                    <div class="input-group-append">
                                        <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="eddtfim">até:</label>
                                <div class="input-group">
                                    <date-picker id="eddtfim" v-model="pdtfim" :config="options"
                                        class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo"
                                        @change="mtdlimpar_listagem()"></date-picker>
                                    <div class="input-group-append">
                                        <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbsituacaopesq">Situação:</label>
                                <select name="cbsituacaopesq" class="form-control form-control-sm" id="cbsituacaopesq"
                                    v-model="psituacao" @change="mtdlimpar_listagem()">
                                    <option value="0">Em analise</option>
                                    <option value="1">Reprovada</option>
                                    <option value="2">Aprovada</option>
                                    <option value="3">Cancelada</option>
                                    <option value="4">Efetivada</option>
                                    <option value="5">Todas</option>
                                </select>
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbqtdreg">Registros:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg"
                                    v-model="pqtdregistros" @change="mtdlimpar_listagem()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block"
                                    @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Listar</button>
                            </div>
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table :rows="lstpedido" :columns="columns" :config="config"
                                    :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>
                                    <!--  -->
                                    <template slot="id_f" slot-scope="item">
                                        {{ mtdformatarzeros(item.row.id, 8) }}
                                    </template>
                                    <template slot="slot_totalpedido" slot-scope="item">
                                        <strong style="color: #545b62;">{{ mtdformatavalordecimal(item.row.totalpedido,
                    2) }}</strong>
                                    </template>
                                    <template slot="slot_situacao" slot-scope="item">
                                        <span v-if="parseInt(item.row.situacao) === 0"
                                            class="badge badge-pill badge-primary bdg-digitacao" style="">Em
                                            analise</span>
                                        <span v-else-if="parseInt(item.row.situacao) === 1"
                                            class="badge badge-pill badge-primary bdg-aguardando">Reprovado</span>
                                        <span v-else-if="parseInt(item.row.situacao) === 2"
                                            class="badge badge-pill badge-primary bdg-entregue">Aprovado</span>
                                        <span v-else-if="parseInt(item.row.situacao) === 3"
                                            class="badge badge-pill badge-primary bdg-cancelado">Cancelado</span>
                                        <span v-else-if="parseInt(item.row.situacao) > 3"
                                            class="badge badge-pill badge-primary bdg-efetivado">Efetivado</span>
                                    </template>
                                    <template slot="opcoes" slot-scope="item">
                                        <div>
                                            <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn"
                                                @click.prevent="mtdalterar(item.row, item.row.situacao)"><i
                                                    class="fa fa-edit"></i></button>
                                            <button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn"
                                                @click.prevent="mtdexcluir(item.row)"><i
                                                    class="fa fa-trash"></i></button>
                                            <button type="button" class="btn btn-primary btn-sm btn-opcrud ajt-btn"
                                                @click.prevent="mtdefetivar(item.row)"><i
                                                    class="fa fa-bolt"></i></button>
                                            <button type="button" class="btn btn-secondary btn-sm btn-opcrud ajt-btn"
                                                @click.prevent="mtdimprimirgarantia(item.row.id, item.row.situacao)"><i
                                                    class="fa fa-print"></i></button>
                                        </div>
                                    </template>
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-md-12">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center"
                                        style="padding: 10px;">
                                        Registros
                                        <span
                                            class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{ lstpedido.length }}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-8 col-sm-8 col-md-10 col-lg-10" id="dvpaginacao">
                                <v-pagination v-model="pagina_atual" :page-count="pqtd_paginas"
                                    :classes="bootstrapPaginationClasses">
                                </v-pagination>
                            </div>
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-success btn-sm btn-block"
                                    @click.prevent="mtdnovo()"><i class="fa fa-file"></i> Novo</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pncadastro" class="card" style="display:none;">
                    <div class="card-header"><span>{{ itensbc.item2.titulo }}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                            @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edid">Nr. Garantia:</label>
                                <input type="text" class="form-control form-control-sm" id="edid" v-model="vid"
                                    maxlength="20" disabled />
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <span class="lblselect2">*Filial:</span>
                                <select id="cbfilial" data-placeholder="Selecione uma filial" v-model="vidfilial"
                                    v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-md-2">
                                <span class="lblselect2">*Fornecedor:</span>
                                <select id="cbfornecedor" data-placeholder="Selecione um fornecedor"
                                    data-allow-clear="true" style="width:100%;" v-model="vidfornecedor"
                                    v-bind:disabled="ativadesativa">
                                </select>
                            </div>
                            <div class="col-md-2">
                                <span class="lblselect2">*Vendedor:</span>
                                <select id="cbvendedor" data-placeholder="Selecione um vendedor" data-allow-clear="true"
                                    style="width:100%;" v-model="vidvendedor" v-bind:disabled="ativadesativa">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="eddtemissao">*Dt. Emissão:</label>
                                <div class="input-group">
                                    <date-picker id="eddtemissao" v-model="vdtemissao" :config="options"
                                        class="form-control form-control-sm"
                                        v-bind:disabled="ativadesativa"></date-picker>
                                    <div class="input-group-append">
                                        <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="eddtentrega">*Dt. Entrega:</label>
                                <div class="input-group">
                                    <date-picker id="eddtentrega" v-model="vdtentrega" :config="options"
                                        class="form-control form-control-sm"
                                        v-bind:disabled="ativadesativa"></date-picker>
                                    <div class="input-group-append">
                                        <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" style="margin-top: 10px;">
                            <div class="col-md-12">
                                <ul class="nav nav-tabs" role="tablist">
                                    <li class="nav-item">
                                        <a class="nav-link active" data-toggle="tab" href="#dvitens">Itens</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvobservacoes">Observações</a>
                                    </li>
                                </ul>
                                <div class="tab-content border-left border-right border-bottom"
                                    style="padding-top: 15px; padding-bottom: 15px;">
                                    <div id="dvitens" class="container-fluid tab-pane active">
                                        <div v-show="parseInt(this.opcrud) < 3" class="row">
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edidprodutoedicao">*Produto:</label>
                                                <div class="input-group" style="z-index: 1;">
                                                    <input type="text" class="form-control form-control-sm"
                                                        id="edidprodutoedicao" v-model="vcoddigedicao" maxlength="20"
                                                        v-on:blur="mtdlocalizarproduto(vcoddigedicao)"
                                                        v-on:keyup.13="mtdlocalizarproduto(vcoddigedicao)"
                                                        style="text-transform: uppercase;">
                                                    <div class="input-group-append">
                                                        <a href="#" class="btn btn-info btn-sm btn-grupo-pesq"
                                                            role="button" @click.prevent="mtdconsultarproduto()"><i
                                                                class="fa fa-search" style="padding-top: 3px;"></i></a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <span class="lblselect2">*Cliente:</span>
                                                <select id="cbcliente" data-placeholder="Selecione um cliente"
                                                    v-model="vidcliente" v-bind:disabled="ativadesativa"
                                                    data-allow-clear="true" style="width:100%;">
                                                </select>
                                            </div>
                                            <div class="col-sm-12 col-md-4 col-lg-3">
                                                <label for="eddescricaoprodutoedicao">Descrição do produto:</label>
                                                <input type="text" class="form-control form-control-sm"
                                                    id="eddescricaoprodutoedicao" v-model="vdescricaoprodutoedicao"
                                                    maxlength="100" style="font-weight: bold;" disabled>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-1">
                                                <label for="edundprodutoedicao">Und:</label>
                                                <input type="text" class="form-control form-control-sm"
                                                    id="edundprodutoedicao" v-model="vundprodutoedicao"
                                                    data-bv-group=".group" maxlength="2" disabled
                                                    style="font-weight: bold;" />
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-1">
                                                <label for="edqtditemedicao">*Qtd:</label>
                                                <money type="text" class="form-control form-control-sm"
                                                    id="edqtditemedicao" v-model="vqtditemedicao" data-bv-group=".group"
                                                    maxlength="20" style="text-align:right;"></money>
                                            </div>
                                            <div class="col-md-2 col-lg-1">
                                                <label for="edvlunitarioitemedicao">*Valor:</label>
                                                <money type="text" class="form-control form-control-sm"
                                                    id="edvlunitarioitemedicao" v-model="vvlunitarioedicao"
                                                    v-bind="money" data-bv-group=".group" maxlength="20"
                                                    style="text-align: right;"></money>
                                            </div>
                                            <div class="col-md-2 col-lg-2">
                                                <label for="edvlunitarioitemedicao">*Nr pedido:</label>
                                                <input type="text" v-model="vcodped"
                                                    class="form-control form-control-sm" />
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <span class="lblselect2">*Almoxarifado:</span>
                                                <select id="cbalmox" data-placeholder="Selecione um almoxarifado"
                                                    v-model="vidalmox" v-bind:disabled="ativadesativa"
                                                    data-allow-clear="true" style="width:100%;">
                                                </select>
                                            </div>
                                            <div class="col-md-2">
                                                <label for="edtotalitemedicao">Total:</label>
                                                <money type="text" class="form-control form-control-sm"
                                                    id="edtotalitemedicao" v-model="vtotalitemedicao" v-bind="money"
                                                    data-bv-group=".group" maxlength="20" style="text-align: right;"
                                                    disabled></money>
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-3" style="padding-top: 22px;">
                                                <button type="button" class="btn btn-primary btn-sm"
                                                    @click.prevent="mtdadicionaritem()" style="width: 100%;"><i
                                                        class="fa fa-plus"></i> Incluir</button>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-12" style="margin-top: 10px;">
                                                <vue-bootstrap4-table :rows="lstitensgarantia" :columns="columnsitens"
                                                    :config="config" :classes="classes">
                                                    <template slot="empty-results">
                                                        <div class="col-md-12 text-center">Sem dados para visualização
                                                        </div>
                                                    </template>
                                                    <!-- ícones de ordenação da table -->
                                                    <template slot="sort-asc-icon">
                                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                                    </template>
                                                    <template slot="sort-desc-icon">
                                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                                    </template>
                                                    <template slot="no-sort-icon">
                                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                                    </template>
                                                    <!--  -->
                                                    <template slot="slot_idproduto" slot-scope="item">
                                                        {{ item.row.idproduto }}
                                                    </template>
                                                    <template slot="slot_cliente" slot-scope="item">
                                                        {{ item.row.codcliente }} - {{ item.row.cliente }}
                                                    </template>
                                                    <template slot="slot_pedido" slot-scope="item">
                                                        {{ item.row.pedido }}
                                                    </template>
                                                    <template slot="slot_vlunitario" slot-scope="item">
                                                        {{ mtdformatavalordecimal(item.row.vlunitario, 2) }}
                                                    </template>
                                                    <template slot="slot_totalitem" slot-scope="item">
                                                        <strong>{{ mtdformatavalordecimal(item.row.totalitem, 2)
                                                            }}</strong>
                                                    </template>
                                                    <template slot="opcoes" slot-scope="item">
                                                        <button type="button"
                                                            class="btn btn-danger btn-sm btn-opcrud ajt-btn"
                                                            @click.prevent="mtdexcluiritem(item.row)"><i
                                                                class="fa fa-trash"></i></button>
                                                    </template>
                                                </vue-bootstrap4-table>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="dvobservacoes" class="container-fluid tab-pane">
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <textarea class="form-control center" rows="5" id="txtobservacoes"
                                                    v-model="vobservacoes" v-bind:disabled="ativadesativa"></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">

                            <div v-if="vsituacao == 1" class="col-md-8">
                                <label for="edcondicoespagamento">*Motivo:</label>
                                <input type="text" class="form-control form-control-sm" id="edcondicoespagamento"
                                    v-model="vmotivo" maxlength="100" v-bind:disabled="ativadesativa">
                            </div>
                            <div v-else class="col-md-8">

                            </div>
                            <div class="col-md-2">
                                <label for="cbimprimirvalores">*Tipo:</label>
                                <select class="form-control form-control-sm" id="cbimprimirvalores" v-model="vtipo"
                                    v-bind:disabled="ativadesativa">
                                    <option value="0">Gerou credito</option>
                                    <option value="1">Troca</option>
                                    <option value="2">Garantia</option>
                                </select>
                            </div>
                            <div class="col-md-2">
                                <label for="cbsituacao">Situação:</label>
                                <select class="form-control form-control-sm" id="cbsituacao" v-model="vsituacao"
                                    v-bind:disabled="ativadesativa">
                                    <option value="0">Em analise</option>
                                    <option value="1">Reprovada</option>
                                    <option value="2">Aprovada</option>
                                    <option value="3">Cancelado</option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12" style="margin-top: 10px;">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center"
                                        style="padding: 10px;">
                                        <strong style="color: #545b62;">Total</strong>
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info"
                                            style="width: 150px!important;">{{ mtdformatavalordecimal(vtotalpedido, 2)
                                            }}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-sm-8">
                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos com
                                        asterisco(*) devem ser
                                        informados</strong>.</h5>
                            </div>
                            <div class="col-sm-2">
                                <button id="btgravar" v-if="(opcrud == 1)" type="button" @click.prevent="mtdgravar()"
                                    v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                    style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Gravar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 2)" type="button"
                                    @click.prevent="mtdgravar()" v-bind:disabled="validou"
                                    class="btn btn-primary btn-sm" style="width:100%; margin-bottom:10px;"><i
                                        class="fa fa-check"></i> Alterar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 3)" type="button"
                                    @click.prevent="mtdgravar()" v-bind:disabled="validou"
                                    class="btn btn-primary btn-sm" style="width:100%; margin-bottom:10px;"><i
                                        class="fa fa-check"></i> Excluir
                                </button>
                            </div>
                            <div class="col-sm-2">
                                <button type="button" @click.prevent="mtdcancelaredicao()"
                                    class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="fa fa-close"></i> Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import BreadCrumb from '../components/cmpbreadcrumb.vue'
import ConsultarProdutos from '../components/cmpconsultarprodutos.vue'
import VueBootstrap4Table from 'vue-bootstrap4-table'
import vPagination from 'vue-plain-pagination'
import Swal from "sweetalert2/dist/sweetalert2.js"
import "sweetalert2/dist/sweetalert2.min.css"
import util from '../utilitarios/util.js'

export default {
    name: 'cadpedidosgarantiasfor',
    components: {
        VueBootstrap4Table,
        vPagination,
        'breadcrumb': BreadCrumb,
        'consultaprodutos': ConsultarProdutos
    },
    data: function () {
        return {
            //variaveis da consulta de produtos
            vshowprtabela: false,//oculta a visualização do preço do produto na listagem
            vidtabela: 1,//informo somente pq o componente exige
            tipopropesquisa: '',

            lstpedido: [],
            pid: '',
            pidfilial: null,
            pidfornecedor: null,
            pfiltroperiodo: 1,
            pdtini: util.DataAtual(true),
            pdtfim: util.DataAtual(true),
            psituacao: 5,
            pqtdregistros: 10,
            pqtd_paginas: 1,
            pagina_atual: 1,
            pqtd_total_registros: 0,

            //variáveis do crud
            opcrud: 0,
            vid: '',
            vidfilial: null,
            vidfornecedor: null,
            vidvendedor: null,
            vidcliente: null,
            vidalmox: null,
            vdtemissao: util.DataAtual(),
            vdtentrega: util.DataAtual(),
            vmotivo: '',
            vobservacoes: '',
            vtotalpedido: 0,
            vtipo: 0,
            vsituacao: 0,
            lstitensgarantia: [],
            vnomelistaitem: '',
            vcodped: '',
            vdataefetiva: util.DataAtual(),
            controlesit: null,  ///controla a situação 

            //variaveis de edicao do item
            vitem: 0,
            vidprodutoedicao: '',
            vcoddigedicao: '',
            vdescricaoprodutoedicao: '',
            vundprodutoedicao: '',
            vqtditemedicao: 1,
            vfracionadoedicao: 0,
            vreferenciaedicao: '',
            vvlunitarioedicao: 0,
            vtotalitemedicao: 0,

            //variável para habilitação dos campos
            ativadesativa: true,

            money: {
                decimal: ',',
                thousands: '.',
                prefix: '',//aqui colocar o cifrão se for necessário
                precision: 2,
                masked: false
            },
            options: {
                format: 'DD/MM/YYYY',
                useCurrent: false,
                locale: 'pt-BR'
            },
            bootstrapPaginationClasses: {
                ul: 'pagination pagination-sm',
                li: 'page-item',
                liActive: 'active',
                liDisable: 'disabled',
                button: 'page-link'
            },
            itensbc: {
                item1: {
                    titulo: 'GARANTIA DE FORNECEDORES',
                    ativo: false
                },
                item2: {
                    titulo: '',
                    ativo: false
                }
            },
            columns: [
                {
                    label: 'Opções',
                    name: 'opcoes',
                    row_text_alignment: "text-center",
                    column_text_alignment: "text-center",
                    row_classes: "def-col-opcoes-compra",
                    sort: false
                },
                {
                    label: "Nr. garantia",
                    name: "id",
                    sort: true,
                    initial_sort: true,//acrescentar isso na coluna que for iniciar ordenado
                    initial_sort_order: 'asc',
                    slot_name: "id_f",
                    row_classes: "def-col-cod",
                },
                {
                    label: "Filial",
                    name: "fantasiafilial",
                    sort: true,
                    row_text_alignment: "text-left",
                    column_text_alignment: "text-left"
                },
                {
                    label: "Fornecedor",
                    name: "fantasia",
                    sort: true,
                    row_text_alignment: "text-left",
                    column_text_alignment: "text-left"
                },
                {
                    label: "Emissão",
                    name: "dtemissao",
                    sort: true,
                    slot_name: "slot_dtemissao",
                    row_classes: "def-col-dtemissao",
                    row_text_alignment: "text-right",
                    column_text_alignment: "text-left"
                },
                {
                    label: "Entrega",
                    name: "dtentrega",
                    sort: true,
                    slot_name: "slot_dtentrega",
                    row_classes: "def-col-dtentrega",
                    row_text_alignment: "text-right",
                    column_text_alignment: "text-left"
                },
                {
                    label: "Total",
                    name: "totalpedido",
                    sort: true,
                    slot_name: "slot_totalpedido",
                    row_classes: "def-col-totalpedido",
                    row_text_alignment: "text-right",
                    column_text_alignment: "text-left"
                },
                {
                    label: "Situação",
                    name: "situacao",
                    sort: true,
                    slot_name: "slot_situacao",
                    row_classes: "def-col-situacao",
                    row_text_alignment: "text-center",
                    column_text_alignment: "text-left"
                }
            ],
            config: {
                pagination: false,
                pagination_info: false,
                card_mode: false,
                global_search: {
                    visibility: false,
                },
                show_refresh_button: false,
                show_reset_button: false
            },
            classes: {
                table: "table-bordered table-striped table-sm"
            },
            columnsitens: [
                {
                    label: 'Opções',
                    name: 'opcoes',
                    row_text_alignment: "text-center",
                    column_text_alignment: "text-center",
                    row_classes: "def-col-opcoes",
                    sort: false
                },
                {
                    label: "Item",
                    name: "item",
                    sort: true,
                    slot_name: "slot_item",
                    row_classes: "def-col-item",
                    row_text_alignment: "text-right",
                },
                {
                    label: "Código",
                    name: "coddig",
                    sort: true,
                    slot_name: "slot_idproduto",
                    row_classes: "def-col-idproduto",
                    row_text_alignment: "text-right",
                },
                {
                    label: "Descrição",
                    name: "descricao",
                    initial_sort_order: 'asc',
                    sort: true,
                    row_text_alignment: "text-left",
                    column_text_alignment: "text-left"
                },
                {
                    label: "Cliente",
                    name: "cliente",
                    sort: true,
                    slot_name: "slot_cliente",
                    row_text_alignment: "text-left",
                    column_text_alignment: "text-left"
                },
                {
                    label: "Qtd",
                    name: "qtditem",
                    sort: true,
                    row_text_alignment: "text-right",
                    column_text_alignment: "text-left"
                },
                {
                    label: "Und",
                    name: "und",
                    sort: true,
                    row_text_alignment: "text-left",
                    column_text_alignment: "text-left"
                },
                {
                    label: "Nr. Pedido",
                    name: "pedido",
                    sort: true,
                    slot_name: "slot_pedido",
                    row_text_alignment: "text-left",
                    column_text_alignment: "text-left"
                },
                {
                    label: "Pr. Compra",
                    name: "vlunitario",
                    sort: true,
                    slot_name: "slot_vlunitario",
                    row_classes: "def-col-vlunitario",
                    row_text_alignment: "text-right",
                    column_text_alignment: "text-left"
                },
                {
                    label: "Total",
                    name: "totalitem",
                    sort: true,
                    slot_name: "slot_totalitem",
                    row_classes: "def-col-totalitem",
                    row_text_alignment: "text-right",
                    column_text_alignment: "text-left"
                }
            ]
        }
    },
    methods: {
        mtdformatavalordecimal(valor, digitos) {
            if (parseFloat(valor) > 0) {
                return util.formatavalordecimais(valor, digitos);
            } else {
                return 0;
            }
        },
        mtdformatarzeros(str, length) {
            return util.formatarzeros(str, length);
        },
        mtddefiniciais() {
            let vself = this;
            let sqliniusuario = parseInt(vself.utodasfiliais) === 0 ? 'select f.codfil, f.fantasia from tbfiliaisusuario fu left join tbfiliais f on f.codfil=fu.idfilial ' : 'select codfil, fantasia from tbfiliais ';
            let sqlfimusuario = parseInt(vself.utodasfiliais) === 0 ? 'where upper(f.fantasia) like upper("%@@%") and fu.idusuario=' + vself.$store.state.usuario.id : 'where upper(fantasia) like upper("%@@%")';
            $("#cbfornecedorpesq").select2({
                id: function (e) { return e.id },
                ajax: {
                    url: vself.$store.state.configpaths.pathselect2,
                    dataType: 'json',
                    delay: 250,
                    data: function (params) {
                        return {
                            q: params.term,
                            idclientesac: vself.$store.state.filialpadrao.idcliente,
                            tb: 'tbfornecedores',
                            c1: 'id',
                            c2: 'nomerazaosocial'
                        };
                    },
                    processResults: function (data) {
                        return {
                            results: data
                        };
                    },
                    cache: true
                },
                minimumInputLength: 0,
                theme: 'bootstrap',
                language: "pt-BR",
                templateResult: util.formatResult,
                templateSelection: util.formatSelection
            }).change(function () {
                vself.pidfornecedor = $("#cbfornecedorpesq").val();
                vself.mtdlimpar_listagem();
            });

            $("#cbfilialpesq").select2({
                id: function (e) { return e.codfil },
                ajax: {
                    url: vself.$store.state.configpaths.pathselect2sql,
                    dataType: 'json',
                    delay: 250,
                    data: function (params) {
                        return {
                            q: params.term,
                            idclientesac: vself.$store.state.filialpadrao.idcliente,
                            sqlini: sqliniusuario,
                            sqlfim: sqlfimusuario,
                            cpid: 'codfil',
                            cpdesc: 'fantasia'
                        };
                    },
                    processResults: function (data) {
                        return {
                            results: data
                        };
                    },
                    cache: true
                },
                minimumInputLength: 0,
                theme: 'bootstrap',
                language: "pt-BR",
                templateResult: util.formatResult,
                templateSelection: util.formatSelection
            }).change(function () {
                vself.pidfilial = $("#cbfilialpesq").val();
                vself.mtdlimpar_listagem();
            });

            $("#cbfilial").select2({
                id: function (e) { return e.codfil },
                ajax: {
                    url: vself.$store.state.configpaths.pathselect2sql,
                    dataType: 'json',
                    delay: 250,
                    data: function (params) {
                        return {
                            q: params.term,
                            idclientesac: vself.$store.state.filialpadrao.idcliente,
                            sqlini: sqliniusuario,
                            sqlfim: sqlfimusuario,
                            cpid: 'codfil',
                            cpdesc: 'fantasia'
                        };
                    },
                    processResults: function (data) {
                        return {
                            results: data
                        };
                    },
                    cache: true
                },
                minimumInputLength: 0,
                theme: 'bootstrap',
                language: "pt-BR",
                templateResult: util.formatResult,
                templateSelection: util.formatSelection
            }).change(function () {
                vself.vidfilial = $("#cbfilial").val();
            });

            $("#cbfornecedor").select2({
                id: function (e) { return e.id },
                ajax: {
                    url: vself.$store.state.configpaths.pathselect2,
                    dataType: 'json',
                    delay: 250,
                    data: function (params) {
                        return {
                            q: params.term,
                            idclientesac: vself.$store.state.filialpadrao.idcliente,
                            tb: 'tbfornecedores',
                            c1: 'id',
                            c2: 'nomerazaosocial'
                        };
                    },
                    processResults: function (data) {
                        return {
                            results: data
                        };
                    },
                    cache: true
                },
                minimumInputLength: 0,
                theme: 'bootstrap',
                language: "pt-BR",
                templateResult: util.formatResult,
                templateSelection: util.formatSelection
            }).change(function () {
                vself.vidfornecedor = $("#cbfornecedor").val();
            });

            $("#cbvendedor").select2({
                id: function (e) { return e.id },
                ajax: {
                    url: vself.$store.state.configpaths.pathselect2,
                    dataType: 'json',
                    delay: 250,
                    data: function (params) {
                        return {
                            q: params.term,
                            idclientesac: vself.$store.state.filialpadrao.idcliente,
                            tb: 'tbvendedores',
                            c1: 'id',
                            c2: 'nome'
                        };
                    },
                    processResults: function (data) {
                        return {
                            results: data
                        };
                    },
                    cache: true
                },
                minimumInputLength: 0,
                theme: 'bootstrap',
                language: "pt-BR",
                templateResult: util.formatResult,
                templateSelection: util.formatSelection
            }).change(function () {
                vself.vidvendedor = $("#cbvendedor").val();
            });
            $("#cbcliente").select2({
                id: function (e) { return e.id },
                ajax: {
                    url: vself.$store.state.configpaths.pathselect2,
                    dataType: 'json',
                    delay: 250,
                    data: function (params) {
                        return {
                            q: params.term,
                            idclientesac: vself.$store.state.filialpadrao.idcliente,
                            tb: 'tbclientes',
                            c1: 'id',
                            c2: 'nome'
                        };
                    },
                    processResults: function (data) {
                        return {
                            results: data
                        };
                    },
                    cache: true
                },
                minimumInputLength: 0,
                theme: 'bootstrap',
                language: "pt-BR",
                templateResult: util.formatResult,
                templateSelection: util.formatSelection
            }).change(function () {
                vself.vidcliente = $("#cbcliente").val();

                //guga
                let parametros = [
                    { parametro: 'idclientesac', valor: vself.$store.state.filialpadrao.idcliente },
                    { parametro: 'op', valor: 'pegadado' },
                    { parametro: 'idcliente', valor: vself.vidcliente },
                    { parametro: 'idfilial', valor: vself.$store.state.filialpadrao.codfil },
                    { parametro: 'idusuario', valor: vself.$store.state.usuario.id },
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv + '/controller/rtcadgarantias.php');
                retorno.then(function (response) {

                    vself.vnomelistaitem = response.data[0].nome;

                    ///retorno bom

                }).catch(function (response) {

                });


            });
            $("#cbalmox").select2({
                id: function (e) { return e.id },
                ajax: {
                    url: vself.$store.state.configpaths.pathselect2,
                    dataType: 'json',
                    delay: 250,
                    data: function (params) {
                        return {
                            q: params.term,
                            idclientesac: vself.$store.state.filialpadrao.idcliente,
                            tb: 'tbestoques',
                            c1: 'id',
                            c2: 'descricao'
                        };
                    },
                    processResults: function (data) {
                        return {
                            results: data
                        };
                    },
                    cache: true
                },
                minimumInputLength: 0,
                theme: 'bootstrap',
                language: "pt-BR",
                templateResult: util.formatResult,
                templateSelection: util.formatSelection
            }).change(function () {
                vself.vidalmox = $("#cbalmox").val();
            });
        },
        mtdformatadatagravar(dtformatar) {
            let strret = dtformatar.replace(/\D/g, "");
            return strret.substring(0, 2) + '/' + strret.substring(2, 4) + '/' + strret.substring(4);
        },
        mtdfiltropesquisa() {
            let rfiltro = '';
            if (this.pid !== '') {
                rfiltro = ' and pg.id=' + this.pid;
            }
            if (this.pidfilial !== null) {
                rfiltro = rfiltro + ' and pg.idfilial=' + this.pidfilial;
            }
            if (this.psituacao < 5) {
                rfiltro = rfiltro + ' and pg.situacao=' + this.psituacao;
            }
            if (this.pidfornecedor !== null) {
                rfiltro = rfiltro + ' and pg.idfornecedor=' + this.pidfornecedor;
            }
            if (parseInt(this.pfiltroperiodo) === 1) {
                rfiltro = rfiltro + ' and pg.dtemissao between "' + util.InverterData(this.pdtini) + '" and "' + util.InverterData(this.pdtfim) + '"';
            }
            return rfiltro;
        },
        mtdexecutapesquisa() {
            var vself = this;
            let filtro = vself.mtdfiltropesquisa();
            this.pagina_atual = 1;
            let parametros = [
                { parametro: 'idclientesac', valor: vself.$store.state.filialpadrao.idcliente },
                { parametro: 'op', valor: 'qtdregistros' },
                { parametro: 'filtro', valor: filtro }
            ];
            let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv + '/controller/rtcadgarantias.php');
            retorno.then(function (response) {
                vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                let qtdpg = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                vself.pqtd_paginas = qtdpg > 0 ? qtdpg : 1;
                vself.mtdcarregapedidos(1);
            }).catch(function (response) {
                alert('Erro ao consultar registros');
            });
        },
        mtdcarregapedidos(ipagina) {
            var vself = this;
            let loader = this.$loading.show();
            let filtro = vself.mtdfiltropesquisa();
            let parametros = [
                { parametro: 'idclientesac', valor: vself.$store.state.filialpadrao.idcliente },
                { parametro: 'op', valor: 'listagem' },
                { parametro: 'filtro', valor: filtro },
                { parametro: 'limit', valor: vself.pqtdregistros },
                { parametro: 'offset', valor: (parseInt(ipagina) - 1) * parseInt(vself.pqtdregistros) },
            ];
            let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv + '/controller/rtcadgarantias.php');
            retorno.then(function (response) {
                vself.lstpedido = response.data;
                loader.hide();
            }).catch(function (response) {
                vself.lstpedido = [];
                loader.hide();
            });
        },
        resetarDados() {
            util.toTop();
            this.vitem = 0;
            this.vid = '';
            this.vidfilial = null;
            this.vidfornecedor = null;
            this.vidvendedor = null;
            this.vdtemissao = util.DataAtual();
            this.vmotivo = '';
            this.vobservacoes = '';
            this.vidvendedor = '';
            this.vtotalpedido = 0;
            this.vtipo = 0;
            this.vsituacao = 0;
            this.lstitensgarantia = [];

            $("#cbfilial").val(null).trigger('change');
            $("#cbfornecedor").val(null).trigger('change');
            $("#cbvendedor").val(null).trigger('change');


            this.mtdlimparedicaoitem();

        },
        mtddefault() {
            $('#pnlista').hide();
            this.resetarDados();
            $('#pncadastro').fadeIn(700);
            setTimeout(() => {
                if (parseInt(this.opcrud) < 3) {
                    $('#cbfilial').select2('open');
                } else {
                    $('#btgravar').focus();
                }
            }, 200);
        },
        mtdpreparacrud(op) {
            let vself = this;
            vself.opcrud = op;
            $('.nav-tabs a[href="#dvitens"]').tab('show');
            vself.mtddefault();
        },
        mtdnovo() {
            if (!util.opcaousuario('010Z.050Z.010Z', this.$store.state.perfilusuario)) {
                util.notif("warning", 'Acesso não permitido para o usuário!');
            } else {
                this.itensbc.item2.titulo = 'INCLUSÃO DE GARANTIA';
                this.itensbc.item1.ativo = true;
                this.itensbc.item2.ativo = true;
                this.ativadesativa = false;
                this.mtdpreparacrud(1);
            }
        },
        mtdcancelaredicao() {
            this.itensbc.item1.ativo = false;
            this.itensbc.item2.ativo = false;
            $('#pncadastro').hide();
            $('#pnlista').fadeIn(700);
            $('#edconteudopesq').focus();
            setTimeout(function () {
                util.toTop();
            }, 200);
        },
        mtdlimpar_listagem() {
            this.lstpedido = [];
            this.pagina_atual = 1;
            this.filtro = '';
            this.pqtd_total_registros = 0;
            this.pqtd_paginas = 0;
        },
        mtdgravar() {
            let vself = this;
            if (parseInt(vself.opcrud) < 3) {
                if (parseInt(vself.vtodasfiliais) === 0) {
                }
            }
            Swal.fire({
                customClass: {
                    confirmButton: "btn btn-success conf",
                    cancelButton: "btn btn-danger"
                },
                title: "Confirmação",
                text: 'Confirma ' + vself.itensbc.item2.titulo + '?',
                icon: "question",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Sim",
                cancelButtonText: "Cancelar"
            }).then((result) => {
                if (result.isConfirmed) {
                    $('.conf').prop('disabled', true);
                    vself.mtdregistro();
                } else {
                    $('#btgravar').focus();
                }
            });
        },
        mtdlocalizaregistro(id) {
            var vself = this;
            let loader = vself.$loading.show();
            let filtro = ' and pg.id=' + id;
            let parametros = [
                { parametro: 'op', valor: 'listagem' },
                { parametro: 'idclientesac', valor: vself.$store.state.filialpadrao.idcliente },
                { parametro: 'filtro', valor: filtro },
                { parametro: 'limit', valor: 1 },
                { parametro: 'offset', valor: 0 },
            ];
            let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv + '/controller/rtcadgarantias.php');
            retorno.then(function (response) {
                loader.hide();
                vself.mtdigualarcampos(response.data[0]);
                if (parseInt(vself.opcrud) < 3) {
                    $('#cbfilial').select2('open');
                } else {
                    $('#btgravar').focus();
                }
            }).catch(function (response) {
                loader.hide();
            });
        },
        mtdalterar(item, situacao) {
            let vself = this
            if (!util.opcaousuario('010Z.050Z.020Z', this.$store.state.perfilusuario)) {
                util.notif("warning", 'Acesso não permitido para o usuário!');
            } else {
                if (situacao > 3) {
                    util.notif("warning", 'Não é possível alterar uma garantia efetivada!');
                    return
                }
                this.itensbc.item2.titulo = 'ALTERAÇÃO DE GARANTIA';
                this.itensbc.item1.ativo = true;
                this.itensbc.item2.ativo = true;
                this.ativadesativa = false;
                this.mtdpreparacrud(2);
                this.mtdlocalizaregistro(item.id);
            }
        },
        mtdexcluir(item) {
            if (!util.opcaousuario('010Z.050Z.030Z', this.$store.state.perfilusuario)) {
                util.notif("warning", 'Acesso não permitido para o usuário!');
            } else {
                this.itensbc.item2.titulo = 'EXCLUSÃO DE GARANTIA';
                this.itensbc.item1.ativo = true;
                this.itensbc.item2.ativo = true;
                this.ativadesativa = true;
                this.mtdpreparacrud(3);
                this.mtdlocalizaregistro(item.id);
            }
        },
        mtdigualarcampos(registro) {
            this.vid = registro.id;
            this.vidfilial = registro.idfilial;
            this.vidfornecedor = registro.idfornecedor;
            this.vdtemissao = registro.dtemissao;
            this.vdtentrega = registro.dtentrega;
            this.vobservacoes = registro.observacoes;
            this.vmotivo = registro.motivo;
            this.vidvendedor = registro.vendedor;
            this.vtotalpedido = parseFloat(registro.totalpedido);
            this.vtipo = registro.tipo;
            this.vsituacao = registro.situacao;
            this.lstitensgarantia = registro.itens;

            var deffilial = new Option(registro.fantasiafilial, registro.idfilial, true, true);
            $('#cbfilial').append(deffilial).trigger('change');

            var defforn = new Option(registro.fantasia, registro.idfornecedor, true, true);
            $('#cbfornecedor').append(defforn).trigger('change');

            var defvend = new Option(registro.nomevend, registro.vendedor, true, true);
            $('#cbvendedor').append(defvend).trigger('change');


            this.vitem = this.lstitensgarantia[this.lstitensgarantia.length - 1].item;
        },
        mtdregistro() {
            let vself = this;
            let loader = vself.$loading.show();
            let registrocrud = {
                'id': this.vid,
                'idfilial': this.vidfilial,
                'idfornecedor': this.vidfornecedor,
                'dtemissao': this.mtdformatadatagravar(this.vdtemissao),
                'dtentrega': this.mtdformatadatagravar(this.vdtentrega),
                'motivo': this.vmotivo,
                'observacoes': this.vobservacoes,
                'vendedor': this.vidvendedor,
                'totalpedido': this.vtotalpedido,
                'tipo': this.vtipo,
                'situacao': this.vsituacao,
                'itens': this.lstitensgarantia
            };
            let parametros = [
                { parametro: 'idclientesac', valor: vself.$store.state.filialpadrao.idcliente },
                { parametro: 'op', valor: 'rotinacrud' },
                { parametro: 'opcrud', valor: vself.opcrud },
                { parametro: 'registro', valor: JSON.stringify(registrocrud) },
                { parametro: 'idfilial', valor: vself.$store.state.filialpadrao.codfil },
                { parametro: 'idusuario', valor: vself.$store.state.usuario.id },
                { parametro: 'codop', valor: parseInt(this.opcrud) === 1 ? '010Z.050Z.010Z' : parseInt(this.opcrud) === 2 ? '010Z.050Z.020Z' : '010Z.050Z.030Z' },
            ];
            let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv + '/controller/rtcadgarantias.php');
            retorno.then(function (response) {
                loader.hide();
                if ($.isNumeric(response.data)) {
                    util.notif("success", 'Registro processado com sucesso!')
                    vself.pfiltroperiodo = 0;
                    vself.psituacao = 5;
                    vself.pid = parseInt(vself.opcrud) === 1 ? response.data : vself.vid;
                    vself.pqtd_paginas = 1;
                    vself.mtdcancelaredicao();
                    vself.mtdcarregapedidos(1);
                } else {
                    let tpret = response.data.substring(0, 1);
                    switch (tpret) {
                        case 'I':
                            util.notif("warning", response.data.substring(4))
                            break;
                        case 'E': default:
                            util.notif("error", response.data.substring(4))
                            break;
                    }
                }
            }).catch(function (response) {
                loader.hide();
                util.notif("error", 'Erro ao processar o registo. Descrição do erro: ' + response.message);
            });
        },
        mtdlimparedicaoitem() {
            this.vidprodutoedicao = '';
            this.vcoddigedicao = '';
            this.vdescricaoprodutoedicao = '';
            this.vundprodutoedicao = '';
            this.vqtditemedicao = 1;
            this.vfracionadoedicao = 0;
            this.vreferenciaedicao = '';
            this.vvlunitarioedicao = 0;
            this.vtotalitemedicao = 0;
            this.vidcliente = null;
            this.vidalmox = null;
            this.vcodped = '';

            $("#cbalmox").val(null).trigger('change');
            $("#cbcliente").val(null).trigger('change');

        },
        mtdlocalizarproduto(coddig) {
            if (coddig !== '' && coddig !== null) {
                var vself = this;
                let loader = vself.$loading.show();
                let parametros = [
                    { parametro: 'op', valor: 'listagem' },
                    { parametro: 'idclientesac', valor: vself.$store.state.filialpadrao.idcliente },
                    { parametro: 'diretorioimagens', valor: vself.$store.state.configpaths.pathimgprodutos + vself.$store.state.filialpadrao.idcliente },
                    { parametro: 'filtro', valor: '' },
                    { parametro: 'coddig', valor: coddig },
                    { parametro: 'limit', valor: 1 },
                    { parametro: 'offset', valor: 0 },
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv + '/controller/rtcadprodutos.php');
                retorno.then(function (response) {
                    loader.hide();
                    if (response.data.length > 0) {
                        let produto = response.data[0];
                        vself.vidprodutoedicao = produto.id;
                        vself.vdescricaoprodutoedicao = produto.descricao;
                        vself.vundprodutoedicao = produto.und;
                        vself.vfracionadoedicao = produto.fracionado;
                        vself.vreferenciaedicao = produto.referencia;
                        vself.vvlunitarioedicao = produto.prcompra;
                        vself.$nextTick(function () {
                            $('#edqtditemedicao').focus();
                        });
                    } else {
                        util.notif("warning", 'Código informado não cadastrado no sistema!');
                        vself.mtdlimparedicaoitem();
                        $('#edidprodutoedicao').focus();
                    }
                }).catch(function (response) {
                    loader.hide();
                });
            } else {
                this.mtdlimparedicaoitem();
            }
        },
        mtdconsultarproduto() {
            if (parseInt(this.opcrud) < 3) {
                let payload = {
                    abrirtela: true
                };
                this.$store.commit('CONSULTA_PRODUTO_CHANGE', payload);
                let payloadx = {
                    idproduto: null
                };
                this.$store.commit('PRODUTO_RETORNO_CHANGE', payloadx);
            }
        },
        mtdadicionaritem() {
            let vself = this;
            if (this.vcoddigedicao === '') {
                util.notif("warning", 'Código do produto deve ser informado!');
                $('#edidprodutoedicao').focus();
                return;
            }
            if (parseFloat(this.vqtditemedicao) <= 0) {
                util.notif("warning", 'Quantidade inválida!');
                $('#edqtditemedicao').focus();
                return;
            }
            if (parseInt(this.vfracionadoedicao) === 0) {
                if (!Number.isInteger(this.vqtditemedicao)) {
                    util.notif("warning", 'Quantidade não pode ser FRACIONADA!');
                    $('#edqtditemedicao').focus();
                    return;
                }
            }
            if (parseFloat(this.vvlunitarioedicao) === 0) {
                util.notif("warning", 'Informe um valor válido para o item!');
                $('#edvlunitarioitemedicao').focus();
                return;
            }
            if (this.vidcliente === null) {
                util.notif("warning", 'Informe o cliente na edição!');
                return;
            }
            if (this.vidalmox === null) {
                util.notif("warning", 'Informe o almoxarifado!');
                return;
            }
            if ((this.vcodped === '') || (this.vcodped === null)) {
                util.notif("warning", 'Informe o pedido de venda!');
                return;
            }

            vself.vitem++;
            let itemtmp = {
                item: vself.vitem,
                idproduto: vself.vidprodutoedicao,
                descricao: vself.vdescricaoprodutoedicao,
                referencia: vself.vreferenciaedicao,
                coddig: vself.vcoddigedicao,
                qtditem: vself.vqtditemedicao,
                und: vself.vundprodutoedicao,
                codcliente: vself.vidcliente,
                cliente: vself.vnomelistaitem,
                almox: vself.vidalmox,
                pedido: vself.vcodped,
                vlunitario: vself.vvlunitarioedicao,
                totalitem: vself.vtotalitemedicao
            };
            this.vtotalpedido = parseFloat(this.vtotalpedido) + parseFloat(this.vtotalitemedicao);
            vself.lstitensgarantia.push(itemtmp);
            vself.mtdlimparedicaoitem();
            setTimeout(() => {
                $('#edidprodutoedicao').focus();
            }, 200);
        },
        mtdexcluiritem(item) {
            if (parseInt(this.opcrud) < 3) {
                let indiceitem = util.getArrayIndexForKey(this.lstitensgarantia, 'item', item.item);
                this.vtotalpedido = parseFloat(this.vtotalpedido) - parseFloat(this.lstitensgarantia[indiceitem].totalitem);
                this.lstitensgarantia.splice(indiceitem, 1);
            }
        },
        mtdimportaritenscoletor() {
            let vself = this;
            let loader = vself.$loading.show();
            let parametros = [
                { parametro: 'idclientesac', valor: vself.$store.state.filialpadrao.idcliente },
                { parametro: 'op', valor: 'listarcoletor' },
                { parametro: 'idusuario', valor: vself.$store.state.usuario.id }
            ];
            let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv + '/controller/rotinasusuario.php');
            retorno.then(function (response) {
                loader.hide();
                if ($.isNumeric(response.data.inf)) {
                    let itenstmp = response.data.itenscoletor;
                    if (vself.lstitensgarantia.length > 0) {
                        vself.vitem = vself.lstitensgarantia[vself.lstitensgarantia.length - 1].item;
                    } else {
                        vself.vitem = 0;
                    }
                    for (let i = 0; i < itenstmp.length; i++) {
                        if (util.findValInArray(vself.lstitensgarantia, 'idproduto', itenstmp[i].idproduto)) {
                            let ii = util.getArrayIndexForKey(vself.lstitensgarantia, 'idproduto', itenstmp[i].idproduto);
                            vself.lstitensgarantia[ii].qtditem = parseFloat(vself.lstitensgarantia[ii].qtditem) + parseFloat(itenstmp[i].qtd);
                            vself.lstitensgarantia[ii].totalitem = parseFloat(vself.lstitensgarantia[ii].totalitem) + (parseFloat(itenstmp[i].qtd) * parseFloat(itenstmp[i].prcompra));
                            vself.vtotalpedido = parseFloat(vself.vtotalpedido) + (parseFloat(itenstmp[i].qtd) * parseFloat(itenstmp[i].prcompra));
                        } else {
                            vself.vitem++;
                            let itemtmp = {
                                item: vself.vitem,
                                idproduto: itenstmp[i].idproduto,
                                descricao: itenstmp[i].descricao,
                                referencia: itenstmp[i].referencia,
                                coddig: '',
                                qtditem: itenstmp[i].qtd,
                                und: itenstmp[i].und,
                                vlunitario: itenstmp[i].prcompra,
                                totalitem: parseFloat(itenstmp[i].prcompra) * parseFloat(itenstmp[i].qtd)
                            };
                            vself.vtotalpedido = parseFloat(vself.vtotalpedido) + parseFloat(itemtmp.totalitem);
                            vself.lstitensgarantia.push(itemtmp);
                        }
                    }
                }
            }).catch(function (response) {
                loader.hide();
            });
        },
        mtdcalculatotalitem() {
            this.vtotalitemedicao = parseFloat(this.vqtditemedicao) * parseFloat(this.vvlunitarioedicao);
        },
        mtdimprimirgarantia(idpedido, tp) {
            window.open(this.$store.state.configpaths.pathcontrole + 'rtimprimirgarantia.php?idclientesac=' +
                this.$store.state.filialpadrao.idcliente +
                '&idpedido=' + idpedido + '&idu=' +
                this.$store.state.usuario.id, '_blank');
        },
        mtdefetivar(garantia) {
            let vself = this
            var idgarantia = garantia.id
            if (!util.opcaousuario('010Z.050Z.040Z', this.$store.state.perfilusuario)) {
                util.notif("warning", 'Acesso não permitido para o usuário!');
            } else {
                Swal.fire({
                    customClass: {
                        confirmButton: "btn btn-success conf",
                        cancelButton: "btn btn-danger"
                    },
                    title: "Confirmação",
                    text: 'Confirma efetivação?',
                    icon: "question",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Sim",
                    cancelButtonText: "Cancelar"
                }).then((result) => {
                    if (result.isConfirmed) {
                        $('.conf').prop('disabled', true);

                        let parametros = [
                            { parametro: 'idclientesac', valor: vself.$store.state.filialpadrao.idcliente },
                            { parametro: 'op', valor: 'efetiva' },
                            { parametro: 'idcliente', valor: vself.vidcliente },
                            { parametro: 'idfilial', valor: vself.$store.state.filialpadrao.codfil },
                            { parametro: 'idusuario', valor: vself.$store.state.usuario.id },
                            { parametro: 'dtefetiva', valor: vself.mtdformatadatagravar(vself.vdataefetiva) },
                            { parametro: 'idgarantia', valor: parseInt(idgarantia) },
                        ];
                        let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv + '/controller/rtcadgarantias.php');
                        retorno.then(function (response) {
                            if ($.isNumeric(response.data)) {
                                util.notif("success", 'Registro processado com sucesso!')
                                vself.pfiltroperiodo = 0;
                                vself.psituacao = 5;
                                vself.pid = idgarantia;
                                vself.pqtd_paginas = 1;
                                vself.mtdcancelaredicao();
                                vself.mtdcarregapedidos(1);
                            } else {
                                let tpret = response.data.substring(0, 1);
                                switch (tpret) {
                                    case 'I':
                                        util.notif("warning", response.data.substring(4))
                                        break;
                                    case 'E': default:
                                        util.notif("error", response.data.substring(4))
                                        break;
                                }
                            }


                        }).catch(function (response) {
                            util.notif("error", 'Erro ao processar o registo. Descrição do erro: ' + response.message);
                        });
                    } else {
                        $('#btgravar').focus();
                    }
                });


                this.controlesit = 0


            }
        },
        mtdverificasituacaogarantia(idgarantia) {

            let vself = this
            let parametros = [
                { parametro: 'idclientesac', valor: vself.$store.state.filialpadrao.idcliente },
                { parametro: 'op', valor: 'verifica' },
                { parametro: 'idcliente', valor: vself.vidcliente },
                { parametro: 'idfilial', valor: vself.$store.state.filialpadrao.codfil },
                { parametro: 'idgarantia', valor: parseInt(idgarantia) },
            ];
            let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv + '/controller/rtcadgarantias.php');
            retorno.then(function (response) {

                vself.controlesit = response.data[0].situacao


            }).catch(function (response) {

                util.notif("error", 'Erro ao processar o registo. Descrição do erro: ' + response.message);
            });


        }
    },
    mounted: function () {
        if (util.verificasessao(this)) {
            let vself = this;
            let loader = vself.$loading.show();
            let parametros = [
                { parametro: 'op', valor: 'dadosusuario' },
                { parametro: 'idclientesac', valor: vself.$store.state.usuario.idclientesac },
                { parametro: 'idusuario', valor: vself.$store.state.usuario.id }
            ];
            let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv + '/controller/rotinasusuario.php');
            retorno.then(function (response) {
                loader.hide();
                vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                if (util.opcaousuario('010Z.050Z', vself.$store.state.perfilusuario)) {
                    $('#pnlista').fadeIn(700);
                    vself.mtddefiniciais();
                    vself.mtdexecutapesquisa();
                } else {
                    util.notif("warning", 'Acesso não permitido para o usuário!');
                    setTimeout(function () {
                        util.gotoprincipal();
                    }, 1000);
                }
            }).catch(function (response) {
                loader.hide();
                console.log(response.message);
            });
        }
    },
    computed: {
        validou() {
            if (this.vsituacao == 1) {
                return this.vidfilial === null || this.vidfornecedor === null || this.vdtemissao === null || this.vdtentrega === null ||
                    this.vidvendedor === null || this.vmotivo === '' || this.lstitensgarantia.length === 0;
            } else {
                return this.vidfilial === null || this.vidfornecedor === null || this.vdtemissao === null || this.vdtentrega === null ||
                    this.vidvendedor === null || this.lstitensgarantia.length === 0;
            }

        },
        idprodutoretorno() {
            return this.$store.state.produtoretornoconsulta.idproduto;
        },
        selecionaperiodo() {
            if (parseInt(this.pfiltroperiodo) === 0) {
                this.hab_desab_periodo = true;
            } else {
                this.hab_desab_periodo = false;
            }
        }
    },
    watch: {
        pagina_atual(val) {
            this.mtdcarregapedidos(val);
        },
        idprodutoretorno(val) {
            if (val !== null || val !== '') {
                this.vcoddigedicao = val;
                this.mtdlocalizarproduto(this.vcoddigedicao);
            }
        },
        vqtditemedicao() {
            this.mtdcalculatotalitem();
        },
        vvlunitarioedicao(val) {
            this.mtdcalculatotalitem();
        }
    }
}
</script>
<style>
.def-col-cod {
    width: 100px !important;
}

.def-col-opcoes-compra {
    width: 170px !important;
}

.def-col-situacao {
    width: 90px !important;
}

.bdg-digitacao {
    background: #6BA2D0 !important;
}

.bdg-aguardando {
    background: #EEA435 !important;
    color: white;
}

.bdg-entregue {
    background: #5A956A !important;
}

.bdg-efetivado {
    background: #aae551 !important;
}

.bdg-cancelado {
    background: #cc330d !important;
}
</style>